var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "main" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading",
          },
        ],
      },
      [_c("v-page-loading")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isLoading,
            expression: "!isLoading",
          },
        ],
      },
      [
        _c("v-page-header", { attrs: { title: _vm.getPageTitle } }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasLoadingError,
                expression: "hasLoadingError",
              },
            ],
          },
          [
            _c("div", { staticClass: "grid-container" }, [
              _c("p", { staticClass: "text-center" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.loadingError) +
                    "\n                "
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.hasLoadingError,
                expression: "!hasLoadingError",
              },
            ],
          },
          [
            _c("div", { staticClass: "grid-container" }, [
              _c("div", { staticClass: "grid-x" }, [
                _c("div", { staticClass: "cell medium-12" }, [
                  _c("div", { staticClass: "wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "box" },
                      [
                        _c("v-drop-zone-upload", {
                          attrs: {
                            projectNumber: _vm.projectObject.project_number,
                            projectId: _vm.$route.params.project,
                          },
                          on: { onAction: _vm.onChangeFile },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "box" },
                      [
                        _c("div", { staticClass: "filter filter--media" }, [
                          _c("div", { staticClass: "grid-x grid-margin-x" }, [
                            _c(
                              "div",
                              { staticClass: "cell medium-6 large-7" },
                              [
                                _c("p", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("internalfiles.description")
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group form-group--check",
                                  },
                                  [
                                    _c("label", { staticClass: "small" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.filesSelectAll,
                                            expression: "filesSelectAll",
                                          },
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          name: "select_all",
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.filesSelectAll
                                          )
                                            ? _vm._i(_vm.filesSelectAll, null) >
                                              -1
                                            : _vm.filesSelectAll,
                                        },
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$a = _vm.filesSelectAll,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.filesSelectAll =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.filesSelectAll = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.filesSelectAll = $$c
                                              }
                                            },
                                            _vm.onSelectAllFiles,
                                          ],
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("i"),
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("select_all"))
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "cell medium-6 large-5" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group form-group--right",
                                  },
                                  [
                                    _vm.filesTableItemsCount >= 1
                                      ? [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "button small u-extra-small-margin--bottom",
                                              class: {
                                                disabled: _vm.generatingZip,
                                              },
                                              on: { click: _vm.exportFiles },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "internalfiles.button.export"
                                                    )
                                                  ) +
                                                  "\n                                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.zipDownloadFile.name
                                      ? [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "button small secondary u-extra-small-margin--bottom",
                                              attrs: {
                                                download:
                                                  _vm.zipDownloadFile.name,
                                                href: _vm.zipDownloadFile.url,
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "internalfiles.button.download"
                                                    )
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "small",
                                        attrs: { for: "form-element-sort" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("media.selected_files"))
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.filesAction,
                                            expression: "filesAction",
                                          },
                                        ],
                                        staticClass:
                                          "form-control form-control--small form-control--select",
                                        attrs: { id: "form-element-sort" },
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.filesAction = $event.target
                                                .multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                            _vm.onChangeAction,
                                          ],
                                        },
                                      },
                                      [
                                        _vm.$store.getters.userHasPermission(
                                          "internalfiles_delete"
                                        )
                                          ? [
                                              _c(
                                                "option",
                                                { attrs: { value: "delete" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("delete"))
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("v-blocks", {
                          attrs: {
                            id: "media",
                            isLoading: _vm.filesTableLoading,
                            items: _vm.filesTableItems,
                            useDeactivatedSwitch: false,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "block",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-group form-group--check",
                                    },
                                    [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.filesTableItemsSelected[
                                                  row.id
                                                ],
                                              expression:
                                                "filesTableItemsSelected[row.id]",
                                            },
                                          ],
                                          attrs: {
                                            type: "checkbox",
                                            name: "upload[]",
                                          },
                                          domProps: {
                                            value: row.id,
                                            checked: Array.isArray(
                                              _vm.filesTableItemsSelected[
                                                row.id
                                              ]
                                            )
                                              ? _vm._i(
                                                  _vm.filesTableItemsSelected[
                                                    row.id
                                                  ],
                                                  row.id
                                                ) > -1
                                              : _vm.filesTableItemsSelected[
                                                  row.id
                                                ],
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.filesTableItemsSelected[
                                                    row.id
                                                  ],
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = row.id,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.filesTableItemsSelected,
                                                      row.id,
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.filesTableItemsSelected,
                                                      row.id,
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.filesTableItemsSelected,
                                                  row.id,
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("i"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "media media--block" },
                                        [
                                          row.type[0] === "image"
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "media--block__thumbnail",
                                                    style:
                                                      "background-image: url(" +
                                                      row.path +
                                                      ");",
                                                    attrs: {
                                                      href: row.path,
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(row.filename))]
                                                ),
                                              ]
                                            : [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "media--block__thumbnail",
                                                    class: row.type[1],
                                                    attrs: {
                                                      href: row.path,
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(row.filename))]
                                                ),
                                              ],
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "media--block__content",
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "title" },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(row.filename)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(_vm._s(row.comment)),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "button button--action button--action--edit button--small",
                                          attrs: { title: _vm.$t("update") },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onUploadObject(
                                                "update",
                                                row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(_vm.$t("update")) +
                                              "\n                                            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("v-pagination", {
                          attrs: {
                            currentPage: _vm.filesTableCurrentPage,
                            itemsPerPage: _vm.filesTableItemsPerPage,
                            items: _vm.filesTableItemsCount,
                          },
                          on: { pageClicked: _vm.onChangeFilesTablePage },
                        }),
                        _vm._v(" "),
                        _c("v-upload-dialog", {
                          attrs: {
                            projectId: _vm.$route.params.project,
                            method: _vm.upload.method,
                            isVisible: _vm.upload.isVisible,
                          },
                          on: { onAction: _vm.onChangeFile },
                          model: {
                            value: _vm.upload.media,
                            callback: function ($$v) {
                              _vm.$set(_vm.upload, "media", $$v)
                            },
                            expression: "upload.media",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }